import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Header } from '../../models/header.model';
import { ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { NgOptimizedImage } from '@angular/common';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-header-content-page',
  imports: [NgOptimizedImage, ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe],
  templateUrl: './header-content-page.component.html',
  styleUrl: './header-content-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderContentPageComponent {
  header = input<Partial<Header>>();
}
